import React from 'react';

import Link from 'next/link';

import useWindowSize from '@components/common/hooks/useWindowSize';
import { M_DEVICE } from '@components/lpc/Constants';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './Header.module.scss';

const Header = () => {
    const { width } = useWindowSize();

    return (
        <div className={css.tfa_header}>
            <section className={css.tfa_header__left}>
                <Link href={getRoute(ROUTE.LPC.HOME)}>
                    <img
                        className={css.tfa_header__left__logo}
                        src={
                            width < M_DEVICE
                                ? '/front-static/icons/logo/lpc.svg'
                                : '/front-static/icons/logo/lpc-with-txt.svg'
                        }
                        alt={'Le pot commun'}
                    />
                </Link>
            </section>
        </div>
    );
};

export default Header;
